import * as React from "react";
import { ErrorComponent } from "../base/Error.component";
import { SharedDocumentApi } from "../../api/SharedDocumentApi";
import {useParams} from "react-router";

export const DownloadDocumentComponent: React.FC = () => {
    const [isRejected, setIsRejected] = React.useState(false);
    const { documentIdParam } = useParams();
    const documentId = parseInt(documentIdParam!, 10);

    React.useEffect(() => {
        SharedDocumentApi.getSharedDocumentData(documentId)
            .then((result) => {
                if (result.data) {
                    SharedDocumentApi.getDocumentDownload(documentId, result.data.fileName, false);
                    setIsRejected(false);
                }
            })
            .catch(() => {
                setIsRejected(true);
            });
    }, [documentIdParam]);

    return isRejected
        ? <ErrorComponent/>
        : <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
            background: "white",
        }} data-testid="download-document-page"/>;
};